var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 187.1 187.1",
    style: {
      enableBackground: "new 0 0 187.1 187.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#170A33;stroke-width:7.0008;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0005;}\n\t.st1{fill:none;stroke:#170A33;stroke-width:7;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:none;stroke:#170A33;stroke-width:6.0006;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0004;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13329",
    transform: "translate(-122.62 -542.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check-broken",
    className: "st0",
    d: "M194.9,719.3c-45.4-12.2-72.3-58.9-60.1-104.3c12.2-45.4,58.9-72.3,104.3-60.1 s72.3,58.9,60.1,104.3c-3.3,12.4-9.5,23.9-17.9,33.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-broken-2",
    className: "st1",
    d: "M167.5,610.9c14.5-27.3,48.5-37.7,75.8-23.1c27.3,14.5,37.7,48.5,23.1,75.8 c-14.5,27.3-48.5,37.7-75.8,23.1c-7.5-4-14-9.6-18.9-16.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-broken-3",
    className: "st2",
    d: "M237.1,620.2c9.3,11.1,7.8,27.6-3.2,36.9c-11.1,9.3-27.6,7.8-36.9-3.2 c-9.3-11.1-7.8-27.6,3.2-36.9c3-2.5,6.6-4.4,10.4-5.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.45b5c216a066574e81ca85d4d72f2ba0.svg";
export { ForwardRef as ReactComponent };